var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcelGreenLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#2E7D32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6094 36H29.1562L24.5625 27.7812C24.4271 27.5312 24.276 27.1771 24.1094 26.7188H24.0469C23.9531 26.9479 23.7969 27.3021 23.5781 27.7812L18.8438 36H14.3594L21.7031 24.7344L14.9531 13.5938H19.5L23.5469 21.1562C23.8073 21.6562 24.0417 22.1562 24.25 22.6562H24.2969C24.599 22 24.8594 21.4792 25.0781 21.0938L29.2812 13.5938H33.4688L26.5625 24.7031L33.6094 36Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelGreenLg);
export default __webpack_public_path__ + "static/media/excelGreenLg.7d6bbbdcdf7bd230a7b95fb12fba3995.svg";
export { ForwardRef as ReactComponent };